<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item @click="preview(params.data)"
            >Preview</vs-dropdown-item
          >
          <vs-dropdown-item @click="editTemplate(params.data)"
            >Edit</vs-dropdown-item
          >
          <vs-dropdown-item
            @click="openConfirm(params.data.certificate_template_id, 'single')"
            >Delete</vs-dropdown-item
          >
          <vs-dropdown-item
            :disabled="params.data.type == 1 || params.data.type == 2"
            @click="generate(params.data)"
            >Generate Certificate</vs-dropdown-item
          >
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererAction",
  data() {
    return {};
  },

  methods: {
    preview(data) {
      this.params.colDef.cellRendererParams.preview(data);
    },

    editTemplate(editingObject) {
      this.params.colDef.cellRendererParams.editTemplate(editingObject);
    },
    generate(editingObject) {
      this.params.colDef.cellRendererParams.generate(editingObject);
    },
    openConfirm(id) {
      this.params.colDef.cellRendererParams.openConfirm(id);
    }
  }
};
</script>
